<div class="tethered-input-container">
    <div class="input-container">
        <span class="colorlabel">{{labelOne}}</span><br>
        <div class="timeinputcontainer">
            <input class="uk-input" type="number" min="0" [(ngModel)]="valueOne" (ngModelChange)="updateValueOne($event)" pattern="\d*">
            <span class="timeFormat">{{ timeOne.hours }}:{{ timeOne.minutes }}:{{ timeOne.seconds }}</span>
        </div>
    </div>
    <div class="input-container">
        <span class="colorlabel">{{labelTwo}}</span><br>
        <div class="timeinputcontainer">
            <input class="uk-input" type="number" min="0" [(ngModel)]="valueTwo" (ngModelChange)="updateValueTwo($event)" pattern="\d*">
            <span class="timeFormat">{{ timeTwo.hours }}:{{ timeTwo.minutes }}:{{ timeTwo.seconds }}</span>
        </div>
    </div>
</div>